import { ifBaseApiPath } from '../../../config/baseConfig';

export interface EntryDatesResponse {
  projectId: string;
  entryType: string;
  noEntryDates: string[];
}

export type EntryType = 'GAS_OPENING_ENTRY' | 'ELEC_START_ENTRY';

/**
 * APIから申込不可日を取得する
 */
export const fetchNoEntryDates = async (
  entryType: EntryType,
  startDate: string,
  endDate: string
): Promise<string[]> => {
  try {
    const endpoint = `${ifBaseApiPath}/application/og-no-entry-dates`;

    const method = 'GET';
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    const params = new URLSearchParams({
      entryType: entryType,
      startDate: startDate,
      endDate: endDate
    });

    const response = await fetch(`${endpoint}?${params}`, {
      method,
      headers,
      mode: 'cors'
    });

    if (response.status === 200) {
      const data: EntryDatesResponse = await response.json();
      return data.noEntryDates || [];
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
